import { useState, useCallback, useRef, createContext, useContext } from 'react';
import { useHandler } from '../handlers/useHandler';
import { jsx as _jsx } from "react/jsx-runtime";
const OverlayContext = /*#__PURE__*/createContext({
  closeOverlay: () => {}
});
export const useCloseOverlay = () => {
  const context = useContext(OverlayContext);
  if (!context) {
    throw new Error('Overlay context not found');
  }
  return context.closeOverlay;
};
export const OverlayContainer = () => {
  const [openPanel, setOpenPanel] = useState(false);
  const UserOverlay = useRef(null);
  const onOpen = useCallback(options => {
    UserOverlay.current = options.overlay;
    setOpenPanel(true);
  }, [UserOverlay, setOpenPanel]);
  const closeOverlay = useCallback(() => setOpenPanel(false), [setOpenPanel]);
  useHandler('onOpenOverlay', onOpen);
  if (!openPanel) {
    return null;
  }
  return /*#__PURE__*/_jsx(OverlayContext.Provider, {
    value: {
      closeOverlay
    },
    children: UserOverlay.current !== null && UserOverlay.current()
  });
};